import { useState , useEffect,useRef} from "react";
import axiosInstance from "../services/axiosInstance";
import Pagination from "../components/Pagination";
import Loader from "../components/Loader";


export default function Users() {
  const [hasTyped, setHasTyped] = useState(false);
  const [users, setUsers] = useState([
    // { id: 1, username: "admin", email: "admin@school.com", role: "ADMIN", password: "admin123" },
    // { id: 2, username: "teacher1", email: "teacher1@school.com", role: "TEACHER", password: "teach123" },
    // { id: 3, username: "parent1", email: "parent1@school.com", role: "PARENT", password: "parent123" },
    ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const [errors, setErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  

 //const [visiblePasswordId, setVisiblePasswordId] = useState(null);
  

  const [searchName, setSearchName] = useState("");
  //const [searchEmail, setSearchEmail] = useState("");
  const [searchRole, setSearchRole] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  const hasFetched = useRef(false);

   useEffect(() => {
     if (hasFetched.current) return;
      hasFetched.current = true;
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/users/retrieve");
      setUsers(response.data);
    } catch (err) {
      alert("Failed to load users,Please retry");
    } finally {
      setLoading(false);
    }
  };

  const onClosePopup = () => {
    setErrors([]);
    setSuccessMessage("");
    setSelectedUser(null);
    fetchUsers();
  };

  // Filter Logic
  const filteredUsers = hasTyped?users.filter((user) => {
    const username = user.username || "";
    const email = user.email || "";
    const role = user.role || "";
    return (
           (username.toLowerCase().includes(searchName.toLowerCase()) ||
          email.toLowerCase().includes(searchName.toLowerCase())) &&
          (searchRole === "" || role === searchRole)
    );
  }):users;
  const currentUsers = filteredUsers.slice(indexOfFirst, indexOfLast);

  const handleSave = async () => {//Save Logic
      try {
        setLoading(true);
        setErrors([]);
        setSuccessMessage("");
        const response = await axiosInstance.post("/users/save", selectedUser);
        if (response.data.status === "SUCCESS") {
         // alert("User Saved successfully");
          setSuccessMessage("Saved successfully");
          selectedUser(response.data.data);
          //setShowModal(false);
          //fetchUsers();
        } else {
           if (response.data.errors && response.data.errors.length > 0) {
                // alert(response.data.errors.join("\n")); // show all errors
                setErrors(response.data.errors);
            } else {
                // alert(response.message || "Error in Save");
                setErrors(["Error in Save"]);
            }
        }
      } catch (errors) {
         console.log(["Error in Save"]);
      }finally{
        setLoading(false);
      }

    };

  return (
    
    <div>
      {loading && <Loader />}
      {/* Header Section */}
     <div className="flex justify-between items-center mb-6">

        <h2 className="text-2xl font-bold">Users</h2>

        <div className="flex gap-3">

          {/* Refresh Button */}
          <button
            onClick={fetchUsers}
            className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded flex items-center gap-2"
          >
            🔄 Refresh
          </button>

          {/* New User Button */}
          <button
            onClick={() => {
              setSelectedUser({
                firstName: "",
                lastName: "",
                username: "",
                email: "",
                password: "",
                role: "ADMIN",
                isActive: true,
                companyCode: "",
                companyBranch: ""
              });
             // setShowModal(true);
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            + New User
          </button>
        </div>
      </div>
      {/* Search Filters */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <input
          placeholder="Search by Name/Email"
          className="px-3 py-2 border rounded"
          name="random-field-name"
          value={searchName}
          onChange={(e) =>{setSearchName(e.target.value);
            setHasTyped(true);
          }}
        />
        {/* <input
          placeholder="Search by email"
          className="px-3 py-2 border rounded"
          name="random-field-name"
          value={searchEmail}
          onChange={(e) => {setSearchEmail(e.target.value);
          setHasTyped(true);
          }}
        /> */}

        <select
          className="px-3 py-2 border rounded"
          value={searchRole}
          onChange={(e) => {setSearchRole(e.target.value);
          setHasTyped(true); }}
        >
          <option value="">All Roles</option>
          <option value="ADMIN">ADMIN</option>
          <option value="TEACHER">TEACHER</option>
          <option value="PARENT">PARENT</option>
        </select>

      </div>

      {/* Users Table */}
      <div className="bg-white shadow rounded-xl overflow-x-auto">
       <table className="min-w-full text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-4">Username</th>
              <th className="p-4">Email</th>
              <th className="p-4">Active</th>
              <th className="p-4">Role</th>
              <th className="p-4">Actions</th>
            </tr>
          </thead>
         
          <tbody>
            {currentUsers.map(user => (
              <tr key={user.id} className="border-t hover:bg-gray-50">
                <td className="p-4 font-semibold text-gray-900">{user.username}</td>
                <td className="p-4">{user.email}</td>
                <td className="p-4">{user.isActive ? "Yes" : "No"}</td>
                <td className="p-4">{user.role}</td>
                <td className="p-4">
                  <button
                    onClick={() => {
                      setSelectedUser(user);
                      //setShowModal(true);
                    }}
                    className="text-blue-600 hover:underline">
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
            
        </table>
        <Pagination
          totalItems={users.length}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setItemsPerPage={setItemsPerPage}
        />
      </div>

      {/* Modal */}
      {selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center">
         {loading && <Loader />}
         <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl p-6 relative">
          {/* Error block */}
            {errors.length > 0 && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mt-2">
                <ul className="list-disc list-inside text-sm">
                  {errors.map((err, idx) => (
                    <li key={idx}>{err}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Success message */}
            {successMessage && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded mt-2 text-sm">
                {successMessage}
              </div>
            )}
            <h3 className="text-lg font-bold mb-4">
              {selectedUser.id ? "Edit User" : "New User"}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 text-sm mb-6">
            <div>
            <label className="font-medium">UserId</label>
            <input
              className="w-full mb-3 px-3 py-2 border rounded"
              value={selectedUser.username}
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, username: e.target.value })
              }
            />
            {/* {selectedUser.id ? <p
              className="w-full mb-3 px-3 py-2 border rounded"
             value={selectedUser.username}
             >{selectedUser.username}</p> :  
            <input
              className="w-full mb-3 px-3 py-2 border rounded"
              value={selectedUser.username}
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, username: e.target.value })
              }
            />} */}
            </div>
            <div>
            <label className="font-medium">Password</label>
            {selectedUser.id ? <p
              className="w-full mb-3 px-3 py-2 border rounded">************</p> :
              <input
                type="password"
                className="w-full mb-3 px-3 py-2 border rounded"
                value={selectedUser.password}
                onChange={(e) =>
                    setSelectedUser({ ...selectedUser, password: e.target.value })
                }
            />}
            </div>
            <div>
            <label className="font-medium">Email</label>
            <input
              className="w-full mb-3 px-3 py-2 border rounded"
              value={selectedUser.email}
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, email: e.target.value })
              }
            />
            </div>

            <div>
            <label className="font-medium">Role</label>
            <select
              className="w-full mb-4 px-3 py-2 border rounded"
              value={selectedUser.role}
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, role: e.target.value })
              }
            >
              <option value="ADMIN">ADMIN</option>
              <option value="TEACHER">TEACHER</option>
              <option value="PARENT">PARENT</option>
            </select>
            </div>
            <div>
            <label className="font-medium">Is Active</label>
            <select
            className="w-full mb-4 px-3 py-2 border rounded"
              value={selectedUser.isActive}
              onChange={(e) =>
                setSelectedUser({
                  ...selectedUser,
                  isActive: e.target.value === "true"
                })
              }
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
            </div>
            <div>
            <label className="font-medium">Name</label>
            <input
             className="w-full mb-3 px-3 py-2 border rounded"
              value={selectedUser.empName} disabled
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, empName: e.target.value })
              }
            />
            </div>

            {/* <input
              className="w-full mb-3 px-3 py-2 border rounded"
              placeholder="Last Name"
              value={selectedUser.lastName}
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, lastName: e.target.value })
              }
            /> */}
            </div>
            <div className="flex justify-end gap-3">
              <button
                onClick={onClosePopup}
                className="px-4 py-2 border rounded">
                Cancel
              </button>

              <button
                onClick={handleSave}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Save
              </button>
            </div>

          </div>

        </div>
      )}

    </div>
  );
}